import { CSSProgressiveHeading02 } from "@caisy/league";
import styled from "styled-components";

export const SPricingCardTitle = styled.div`
  ${CSSProgressiveHeading02};
  color: var(--text-01);
`;
